import { isTokenExpired } from "../helpers/TokenHelper";
import { DashboardOrderListModel } from "models/DashboardOrderList.Model";
import createHttpInstance from "./http-common";


class EnquiryServices {
    private serviceName = '/Enquiry';

    async DownloadElasticEnquiryList(data: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/DownloadElasticEnquiryList`, data).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetEnquiryList(data: DashboardOrderListModel) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetElasticEnquirySearchResult`, data).catch((err: Error) => {
            throw err?.message;
        })
    }

    async GetEnquirySummary(id: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/GetEnquirySummary/${id}`).catch((err: Error) => {
            throw err?.message;
        });
    }

    async AdminReEvaluteOrder(id: any) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/AdminReEvaluteOrder/${id}`).catch((err: Error) => {
            throw err?.message;
        });
    }

    async AdminRecalculationOrder(data: Array<any>, enquiryId: any, isFromPublic: boolean = false) {
        isTokenExpired();
        const httpCommon = await createHttpInstance();
        return httpCommon.post(`${this.serviceName}/AdminRecalculationOrder?enquiryId=${enquiryId}&isFromPublic=${isFromPublic}`, data).catch((err: Error) => {
            throw err?.message;
        });
    }
}

export default new EnquiryServices();

